import React from 'react';

const RetryDeliveryCallback = ({ match, location, history }) => {
  const status = match.params.status;
  const xltID = (location && location.state && location.state.xltID) || '';
  const hawb = (location && location.state && location.state.hawb) || '';
  console.log(`RetryDeliveryCallbackPage status ${status}, xltID=${xltID}, hawb=${hawb}`);

  function renderContent() {
    if (status === 'success') {
      return (
        <>
          <h1>
            התקבל תשלום עבור ביצוע שליחות חוזרת!
          </h1>
          <p style={{ marginTop: '25px' }}>
            <strong>מס’ למעקב: </strong>
            <span>&nbsp; {hawb}</span>
          </p>
          <button className='btn medium orange centered' onClick={() => history.push(`/tracking/${hawb}`)}>מעקב משלוח</button>
        </>
      );
    }

    if (status === 'error') {
      return (
        <div className='sms-message'>
          <h1>
            ארעה שגיאה בביצוע התשלום {location.state && location.state.body && location.state.body.ErrorText && `(${location.state.body.ErrorText})`}.<br />
            אנא נסו שוב או צרו קשר עם שירות הלקוחות.
          </h1>
          {location.state && location.state.body && location.state.body.ErrorCode && `קוד שגיאה: ${location.state.body.ErrorCode}`}
        </div>
      );
    }

    if (status === 'cancelled') {
      return (
        <div className='sms-message'>
          <h1>
            הזמנת שליחות חוזרת בוטלה.
          </h1>
        </div>
      );
    }

    console.error(`Unexpected status ${status}`);
    return null;
  }

  return (
    <div className='sms-content-wrap'>
      {renderContent()}
    </div>
  );
};

export { RetryDeliveryCallback };
